import axios from "axios";
import config from "../config";

// Eine geteilte Instanz für die ganze App (die API ist bewusst öffentlich, keine Auth)
const instance = axios.create({
  baseURL: config.api.url,
  headers: {
    "cache-control": "no-cache",
  },
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.data) {
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error.message);
  }
);

export default instance;
